module.exports = __webpack_public_path__ + "img/icon-close.1e9dd254.svg";